// This is just a rendering of the player's history chart,
// for purposes of scraping at compiling time and saving as a PNG.

// Third-party libraries
import React, { Component } from "react";

// Project dependencies
import PlayerChart from "../components/PlayerChart";
import { LoadingBar } from "../components/widgets";
import { getHeaders, playerUrl, errorHandler } from "../apihelpers";

class ScoreHistory extends Component {
  state = { notFound: false };

  getPlayerData() {
    const headers = getHeaders();
    fetch(playerUrl + "/" + this.props.match.params.handle, {
      method: "GET",
      headers
    })
      .then(errorHandler)
      .then(data => {
        this.setState({ ...data, notFound: false });
      })
      .catch(error => {
        console.log(error);
        this.setState({ notFound: true });
      });
  }

  componentDidMount() {
    this.getPlayerData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.getPlayerData();
    }
  }

  render() {
    if (this.state.screen_name) {
      return (
        <PlayerChart
          history={this.state.history}
          makePNG={true}
          height="400"
          handle={this.state.handle}
          overall_max={this.state.overall_max}
        />
      );
    }
    else {
        return <LoadingBar />
    }
  }
}

export default ScoreHistory;
